export const fastOptions = [
  { from: "08:00", to: "17:00" },
  { from: "14:00", to: "20:00" },
  { from: "17:00", to: "00:00" }
];

export const sickOrVabTypes = ["Work", "OnCall", "PreparednessA", "PreparednessB"];

export const weekDays = ["mån", "tis", "ons", "tors", "fre", "lör", "sön"];
